import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '',
      region: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
    },
  },
};

// Configure Amplify
Amplify.configure(awsConfig);

export default awsConfig;
